<div class="loading-wrapper">
	<div class="background"></div>
	<div class="loader"></div>
</div>